/** Tiny hand-drawn SVG decorations for the Notebook-Doodle theme. */

export const DoodleStar = ({ color = '#448AFF', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M8 1.5l2 4.5 5 .5-3.8 3.3L12.5 15 8 12l-4.5 3 1.3-5.2L1 6.5l5-.5z"
      stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DoodleAtom = ({ color = '#66BB6A', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <circle cx="8" cy="8" r="2" stroke={color} strokeWidth="1.2" />
    <ellipse cx="8" cy="8" rx="6" ry="3" stroke={color} strokeWidth="1" transform="rotate(30 8 8)" />
    <ellipse cx="8" cy="8" rx="6" ry="3" stroke={color} strokeWidth="1" transform="rotate(-30 8 8)" />
  </svg>
);

export const DoodleLightbulb = ({ color = '#FFD740', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M8 2C5.5 2 4 3.8 4 5.8c0 1.5.8 2.5 1.5 3.2.4.4.5.8.5 1.5v.5h4v-.5c0-.7.1-1.1.5-1.5C11.2 8.3 12 7.3 12 5.8 12 3.8 10.5 2 8 2z"
      stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <path d="M6 13h4M6.5 14h3" stroke={color} strokeWidth="1" strokeLinecap="round" />
    <path d="M8 0v1M3 3l.7.7M13 3l-.7.7M2 7h1M13 7h1" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
  </svg>
);

export const DoodleArrow = ({ color = '#FF6B6B', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M3 12C5 8 8 5 13 3" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <path d="M10 2l3 1-1 3" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DoodleHeart = ({ color = '#FF6B6B', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M8 14S2 10 2 6c0-2.2 1.8-4 4-4 1.2 0 2 .7 2 .7S9.2 2 10 2c2.2 0 4 1.8 4 4 0 4-6 8-6 8z"
      stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DoodleNote = ({ color = '#AB47BC', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M10 2v8c0 2-3 3-3 1.5S10 10 10 10" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="7" cy="11.5" r="2" stroke={color} strokeWidth="1.2" />
  </svg>
);

export const DoodleLeaf = ({ color = '#66BB6A', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M3 13C3 13 3 7 8 3c5 4 5 10 5 10" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 3v10" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
    <path d="M5 8l3-2M11 8l-3-2" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
  </svg>
);

export const DoodleQuestion = ({ color = '#448AFF', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M5.5 5.5c0-2 2-3 3.5-2s1.5 3-1 4c-.5.3-.5.7-.5 1.2" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="7.5" cy="12.5" r="0.8" fill={color} />
  </svg>
);

export const DoodlePlanet = ({ color = '#AB47BC', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <circle cx="8" cy="8" r="4" stroke={color} strokeWidth="1.2" />
    <ellipse cx="8" cy="8" rx="7" ry="2.5" stroke={color} strokeWidth="0.8" transform="rotate(-20 8 8)" />
  </svg>
);

export const DoodleMagnify = ({ color = '#448AFF', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <circle cx="7" cy="7" r="4" stroke={color} strokeWidth="1.2" />
    <path d="M10 10l4 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const DoodlePencil = ({ color = '#FFD740', opacity = 0.5, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M2 14l1-4L11 2l3 3-8 8z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 10l3 3" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
    <path d="M2 14l.5-1.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export const DoodlePi = ({ color = '#448AFF', opacity = 0.2, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ opacity }}>
    <path d="M4 4h8M6 4v8M10 4c0 4-.5 6-1.5 8" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);
